import axios from "axios";
export default {
    data() {
        return{
            requests: [],
            request: null,
            axiosSource:{}
        }
    },
    methods:{
        cancel () {
            this.request.cancel()
            this.clearOldRequest('Cancelled')
        },
        clearOldRequest (msg) {
            this.axiosSource ={}
            this.request.msg = msg
            this.requests.push(this.request)
            this.request = null
        },
        checkRequest(){
            this.axiosSource={}
            if (this.request) { this.cancel() }
            this.axiosSource = axios.CancelToken.source()
            this.request = { cancel: this.axiosSource.cancel, msg: 'Loading...' }
        }
    }
}